import { combineReducers } from '@reduxjs/toolkit';
import { mainReducer } from './slices/main-slice';

export const authReducers = combineReducers({
  main: mainReducer,
});
export type AuthState = ReturnType<typeof authReducers>;
